import React from 'react';
import UploadIcon from '../icons/upload.svg';

const BannerUploadBox = ({ handleClick, preview, onClear, className, style }) => {
  const handleTouchStart = (e) => {
    // Prevent double-tap zoom on mobile
    e.preventDefault()
    if (handleClick) {
      handleClick(e)
    }
  }

  return (
    <div
      className={`flex items-center justify-between rounded-lg cursor-pointer ${className || ''}`}
      style={{
        ...style,
        background: preview ? 'transparent' : 'var(--input-bg)',
        border: preview ? 'none' : '1px solid var(--input-border)',
        padding: preview ? '0' : '12px',
        minHeight: style?.minHeight || '100px',
        height: style?.minHeight || (preview ? '100%' : 'auto'),
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: preview ? 'stretch' : 'center',
        justifyContent: preview ? 'stretch' : 'space-between',
        // Mobile-friendly styles
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent',
        userSelect: 'none',
        WebkitUserSelect: 'none'
      }}
      onClick={handleClick}
      onTouchStart={handleTouchStart}
    >
      {preview ? (
        <div style={{ 
          position: 'relative', 
          width: '100%', 
          height: '100%', 
          minHeight: style?.minHeight || 'inherit',
          display: 'flex', 
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          borderRadius: '8px'
        }}>
          <img
            src={preview}
            alt="Banner Preview"
            style={{
              width: '100%',
              height: '100%',
              minHeight: style?.minHeight || 'inherit',
              objectFit: 'cover',
              borderRadius: '8px',
              display: 'block'
            }}
          />
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
            className="px-3 py-1 rounded text-sm font-medium"
            style={{
              background: 'var(--button-secondary-bg)',
              color: 'var(--button-secondary-text)',
              border: '1px solid var(--button-secondary-border)',
              position: 'absolute',
              top: '8px',
              right: '8px',
              zIndex: 10
            }}
          >
            Clear
          </button>
        </div>
      ) : (
        <>
          <span style={{ color: 'var(--text-secondary)' }}>Upload Logo</span>
          <img
            src={UploadIcon}
            alt="Upload"
            className="w-5 h-5"
            style={{ filter: 'var(--icon-filter)' }}
          />
        </>
      )}
    </div>
  );
};

export default BannerUploadBox;
